export default __webpack_public_path__ + "static/media/Group 12507.80b5f865.svg";